import {
  LOGGER_ARR_SIZE,
  LOGGER_PUSH_TIME,
  SERVICE_NAME,
  URL
} from './constants';
import { BaseLoggerClass } from './baseLogger';
import { LogLevel, type Message } from './type';

export class EventLoggerClass extends BaseLoggerClass {
  private constructor({
    size = LOGGER_ARR_SIZE,
    time = LOGGER_PUSH_TIME,
    url = URL,
    service = SERVICE_NAME
  }: {
    size?: number;
    time?: number;
    url?: string;
    service?: string;
  }) {
    super(size, time, url, service);
  }

  private static instance: EventLoggerClass | null = null;

  public static getInstance({
    size,
    time,
    url
  }: {
    size?: number;
    time?: number;
    url?: string;
  }): EventLoggerClass {
    if (EventLoggerClass.instance === null) {
      EventLoggerClass.instance = new EventLoggerClass({ size, time, url });
    }
    return EventLoggerClass.instance;
  }

  public logEvent(event: Message, immeadiatePush: boolean = false) {
    this.push({ ...event, level: LogLevel.EVENT }, immeadiatePush);
  }
}

const eventLogger = EventLoggerClass.getInstance({});

export { eventLogger };
